import { getSnapshot, types } from 'mobx-state-tree'
import { DOMAIN_ACTION } from '@/constants'
import { IValueChange } from '@/pages/supplier/listing/definition/accountDetails'
import { axiosPrivateHelper } from '@/utils/axiosHelper'
const axios = axiosPrivateHelper()

const Options = types.model('Options').props({
  isDraft: types.boolean,
})

const FaqList = types.model('FaqList').props({
  id: types.maybeNull(types.string),
  question: types.maybeNull(types.string),
  answer: types.maybeNull(types.string),
  status: types.optional(types.string, 'draft'),
})

export const FaqModel = types
  .model('FaqModel')
  .props({
    supplier_faq: types.optional(types.array(FaqList), []),
    listing_setup_step: types.optional(types.number, 6),
    preValueInput: types.maybeNull(types.optional(FaqList, {})),
    options: types.maybeNull(Options),
    status: types.optional(
      types.enumeration('status', ['changed', 'keep']),
      'keep'
    ),
  })
  .actions((self: any) => {
    const setStatus = (value: 'changed' | 'keep') => {
      self.status = value
    }

    const mapValueChanged = ({ add, value: { faqs } }: IValueChange) => {
      if (add === 'add') {
        self.supplier_faq = faqs
        setStatus('changed')
      }
    }

    const update = async (id: string, data: any = null) => {
      const remapData = getSnapshot(self.supplier_faq) as any[]
      const isAllowSavePreValue = Object.entries(remapData).every(
        (item: any) => item[1] && item[1].length > 0
      )
      const URI = `${DOMAIN_ACTION.API.UPDATE_SUPPLIER_LISTING(id)}`
      const newPayload = remapData.map((item: any) => ({
        ...item,
        status: 'submit',
      }))
      const reduceData = isAllowSavePreValue
        ? newPayload
        : newPayload.filter(
            (item: any) => item.question !== '' || item.answer !== ''
          )

      const payload = {
        listing_setup_step: self.listing_setup_step,
        supplier_faq: reduceData,
      }

      const { promotions } = data || { promotions: [] }
      const paramData = isAllowSavePreValue ? remapData : [...promotions]
      const mapData = { ...data, supplier_faq: paramData }
      const res = await axios.put(URI, data ? mapData : payload)
      return res
    }

    return { setStatus, mapValueChanged, update }
  })
